import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

const CommunityCtaSection = () => (
    <div className="lp-cm-cta">
        <div className="lp-cm-cta-inner">
            <div className="lp-cm-cta-card" data-lp-reveal>
                <h2>Technology gets you transaction-ready. People get you a deal.</h2>
                <p>Come and join the community behind the platform.</p>
                <a href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call with the team</a>
            </div>
        </div>
    </div>
);

export default CommunityCtaSection;
